import { render, staticRenderFns } from "./close-cross.vue?vue&type=template&id=4c59a526&"
import script from "./close-cross.vue?vue&type=script&lang=ts&"
export * from "./close-cross.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports